/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewLocale } from './CRSFSecReviewLocale';
import {
    CRSFSecReviewLocaleFromJSON,
    CRSFSecReviewLocaleFromJSONTyped,
    CRSFSecReviewLocaleToJSON,
} from './CRSFSecReviewLocale';

/**
 * 
 * @export
 * @interface CRSFSecReviewCRATriggerResponse
 */
export interface CRSFSecReviewCRATriggerResponse {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewCRATriggerResponse
     */
    account_line_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewCRATriggerResponse
     */
    agency_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewCRATriggerResponse
     */
    cobranded?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewCRATriggerResponse
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewCRATriggerResponse
     */
    desired_policy_uuid?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewCRATriggerResponse
     */
    domains: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewCRATriggerResponse
     */
    entity_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewCRATriggerResponse
     */
    external_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewCRATriggerResponse
     */
    force?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewCRATriggerResponse
     */
    ip_addresses?: Array<string>;
    /**
     * 
     * @type {CRSFSecReviewLocale}
     * @memberof CRSFSecReviewCRATriggerResponse
     */
    locale?: CRSFSecReviewLocale;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CRSFSecReviewCRATriggerResponse
     */
    metrics?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewCRATriggerResponse
     */
    process_id: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewCRATriggerResponse
     */
    renewal_of_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewCRATriggerResponse
     */
    request_origin?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewCRATriggerResponse
     */
    retained_from_uuid?: string;
}

/**
 * Check if a given object implements the CRSFSecReviewCRATriggerResponse interface.
 */
export function instanceOfCRSFSecReviewCRATriggerResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domains" in value;
    isInstance = isInstance && "process_id" in value;

    return isInstance;
}

export function CRSFSecReviewCRATriggerResponseFromJSON(json: any): CRSFSecReviewCRATriggerResponse {
    return CRSFSecReviewCRATriggerResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewCRATriggerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewCRATriggerResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account_line_uuid': !exists(json, 'account_line_uuid') ? undefined : json['account_line_uuid'],
        'agency_name': !exists(json, 'agency_name') ? undefined : json['agency_name'],
        'cobranded': !exists(json, 'cobranded') ? undefined : json['cobranded'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'desired_policy_uuid': !exists(json, 'desired_policy_uuid') ? undefined : json['desired_policy_uuid'],
        'domains': json['domains'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
        'force': !exists(json, 'force') ? undefined : json['force'],
        'ip_addresses': !exists(json, 'ip_addresses') ? undefined : json['ip_addresses'],
        'locale': !exists(json, 'locale') ? undefined : CRSFSecReviewLocaleFromJSON(json['locale']),
        'metrics': !exists(json, 'metrics') ? undefined : json['metrics'],
        'process_id': json['process_id'],
        'renewal_of_id': !exists(json, 'renewal_of_id') ? undefined : json['renewal_of_id'],
        'request_origin': !exists(json, 'request_origin') ? undefined : json['request_origin'],
        'retained_from_uuid': !exists(json, 'retained_from_uuid') ? undefined : json['retained_from_uuid'],
    };
}

export function CRSFSecReviewCRATriggerResponseToJSON(value?: CRSFSecReviewCRATriggerResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_line_uuid': value.account_line_uuid,
        'agency_name': value.agency_name,
        'cobranded': value.cobranded,
        'currency': value.currency,
        'desired_policy_uuid': value.desired_policy_uuid,
        'domains': value.domains,
        'entity_name': value.entity_name,
        'external_id': value.external_id,
        'force': value.force,
        'ip_addresses': value.ip_addresses,
        'locale': CRSFSecReviewLocaleToJSON(value.locale),
        'metrics': value.metrics,
        'process_id': value.process_id,
        'renewal_of_id': value.renewal_of_id,
        'request_origin': value.request_origin,
        'retained_from_uuid': value.retained_from_uuid,
    };
}

